// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"226edeb7","239":"cb9a7b32","453":"f8bdd5e7","455":"f2f7b7e2"}[chunkId] + ".chunk.js";
};